<template>

  <div id="PrintPrescription">
      <CompanyInfo></CompanyInfo>
        
           <CompanyWatermark />
               <div class="content-wrapper">
     
  <div class="content-area">
  <div class="left-column">
     <p><span class="label">Name</span><span class="colon">:</span><span class="value">{{  patientDetail.name  }}</span></p>
    <p><span class="label">Age</span><span class="colon">:</span><span class="value"> {{ patientDetail.age }}</span></p>
    <p><span class="label">Gender</span><span class="colon">:</span><span class="value">{{ patientDetail.gender }} </span></p>

  </div>
  <div class="right-column">
    <p><span class="label">Date</span><span class="colon">:</span><span class="value"> {{ formattedDate }}</span></p>
    <p><span class="label">Reg No</span><span class="colon">:</span><span> {{ patientId}}</span></p>
    <p><span class="label">Doctor</span><span class="colon">:</span><span class="value"> {{ prescriptionDetail.doctorName }}</span></p>
  </div>
</div>
    

     <div  v-if="prescriptionDetail.doctorOverview" class="doctor-note-box">
        <label>DOCTOR NOTES :</label>
      <div class="note-content">{{ prescriptionDetail.doctorOverview || '-' }}</div>

      </div>
    

    <div class="prescription-wrapper">
  <div class="left-column-prescription">
   
    <div v-if="validMedicines.length" class="medicine-section">
      <h4>MEDICINE</h4>
      <div
        v-for="(m, i) in validMedicines"
        :key="i"
        class="medicine-item"
      >
        <p><b>{{ i + 1 }}. {{ m.medicineName }}</b></p>
           
        <p v-if="m.unit"><b>Unit:</b> {{ m.unit }}</p>
        <p>
          <b>Frequency:</b>
          <span v-if="m.morning"> Morning {{ m.morning }} </span>
          <span v-if="m.afternoon"><br>Afternoon {{ m.afternoon }}</span>
          <span v-if="m.evening"><br>Night {{ m.evening }}</span>
          
        </p>
      </div>
    </div>
  </div>
     
      <div class="right-column-prescription">
      <div v-if=" validLabTests.length" class="lab-section">
      <h4>LAB TEST ADVISE</h4>
      <ol>
        <li v-for="(t, i) in validLabTests" :key="i">{{ t.testName }}</li>
      </ol>
    </div>
      </div>
    </div>
 </div>
  </div>
  
</template>

<script>
import CompanyInfo from '../components/CompanyInfo.vue';
import CompanyWatermark from '@/components/CompanyWatermark.vue'
export default {
   components: {
    CompanyInfo,
     CompanyWatermark
  
   
  },
  props: {
    prescriptionDetail: Object,
    patientDetail: Object,
    medicineData: Array,
    labTests: Array,
    patientId: [String, Number],
  },
  computed: {
    formattedDate() {
      if (!this.prescriptionDetail.prescriptionDate) return "";
      const [year, month, day] = this.prescriptionDetail.prescriptionDate.split("-");
      return `${day}-${month}-${year}`;
    },
    validMedicines() {
      if (!this.medicineData) return [];
      return this.medicineData.filter(
        (m) =>
          m &&
          (
            (m.medicineName && m.medicineName.trim() !== "") ||
            (m.unit && m.unit.trim() !== "") ||
            m.morning || m.afternoon || m.evening
          )
      );
    },

    
    validLabTests() {
      if (!this.labTests) return [];
      return this.labTests.filter(
        (t) => t && t.testName && t.testName.trim() !== ""
      );
    },
  },
};




</script>


